
import qs from "qs"
import JSZip from "jszip"
const auroraSolarWebAppUrl = import.meta.env.VITE_AURORA_SOLAR_WEBAPP_URL

export const defaultImage =
  "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MDIgNTAwIiB2aWV3Qm94PSIwIDAgNTAyIDUwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtMSAwaDUwMHY1MDBoLTUwMHoiIGZpbGw9IiNlOWVlZjEiLz48cGF0aCBkPSJtMzQwLjIgMTk2Ljd2MTA2LjZjMCA5LjgtNy41IDE3LjgtMTYuNyAxNy44aC0xNDQuOWMtOS4yIDAtMTYuNy04LTE2LjctMTcuOHYtMTA2LjZjMC05LjggNy41LTE3LjggMTYuNy0xNy44aDE0NC45YzkuMiAwIDE2LjcgOCAxNi43IDE3Ljh6bS0xNi44IDEwNC40di0xMDIuMmMwLTEuMi0uOS0yLjItMi4xLTIuMmgtMTQwLjdjLTEuMiAwLTIuMSAxLTIuMSAyLjJ2MTAyLjJjMCAxLjIuOSAyLjIgMi4xIDIuMmgxNDAuN2MxLjIgMCAyLjEtMSAyLjEtMi4yem0tMTAzLjEtNzQuOGMwIDguMi02LjIgMTQuOC0xMy45IDE0LjhzLTEzLjktNi42LTEzLjktMTQuOCA2LjItMTQuOCAxMy45LTE0LjggMTMuOSA2LjYgMTMuOSAxNC44em0tMjUgNDEuNSAxMy44LTE0LjZjMS42LTEuNyA0LjMtMS43IDUuOSAwbDEzLjggMTQuNiA0MS42LTQ0LjJjMS42LTEuNyA0LjMtMS43IDUuOSAwbDMwLjUgMzIuNHYyOS42aC0xMTEuNXoiIGZpbGw9IiNiYWJlYzEiLz48L3N2Zz4="

export function isMobile() {
  const navigatorIsMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  const screenIsMobile = window.innerWidth < 768
  return navigatorIsMobile || screenIsMobile
}

export function isEven(n) {
  return n % 2 == 0
}

export function apiUrl(relative) {
  return import.meta.env.VITE_ROOT_API + relative
}

export function formatFullName(obj) {
  return (
    (obj.firstName ? `${obj.firstName} ` : "") +
    (obj.lastName ? `${obj.lastName}` : "")
  )
}

export function getUserDisplayName(user) {
  if (user.type === "BUSINESS") {
    return user.companyName
  } else if (user.type === "PUBLIC_AUTHORITY") {
    return user.publicAuthorityName
  } else {
    return formatFullName(user)
  }
}

export function padTo2Digits(num) {
  return num.toString().padStart(2, "0")
}

export function extractTextFromHTMLString(htmlString) {
  return htmlString.replace(/<[^>]+>/g, " ")
}

export function formatCurrency(
  num,
  locale = "fr-FR",
  currency = "EUR",
  minimumFractionDigits = 2,
) {
  if (isNaN(num)) {
    return num
  }
  return num.toLocaleString(locale, {
    style: "currency",
    currency,
    minimumFractionDigits,
  })
}

export function resizeChartByIds(...ids) {
  const h = window.innerHeight
  let scale

  if (h <= 600) scale = 0.4
  else if (h <= 700) scale = 0.5
  else if (h <= 800) scale = 0.6
  else if (h <= 900) scale = 0.7
  else if (h <= 950) scale = 0.8
  else scale = 1

  ids.forEach((id) => {
    const el = document.getElementById(id)
    if (el) {
      el.style.transform = `scale(${scale})`
      el.style.transformOrigin = "top"
    }
  })
}

export function capitalizeFirstLetter(string) {
  return string?.charAt(0).toUpperCase() + string?.slice(1)
}

export function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000)

  var interval = seconds / 31536000

  if (interval > 2) {
    return Math.floor(interval) + " ans"
  }
  if (interval > 1) {
    return Math.floor(interval) + " an"
  }
  interval = seconds / 2592000
  if (interval > 1) {
    return Math.floor(interval) + " mois"
  }
  interval = seconds / 86400
  if (interval > 1) {
    return Math.floor(interval) + " jour"
  }
  interval = seconds / 3600
  if (interval > 1) {
    return Math.floor(interval) + " heures"
  }
  interval = seconds / 60
  if (interval > 1) {
    return Math.floor(interval) + " minutes"
  }
  return Math.floor(seconds) + " seconde"
}

export function timeDelta(firstDate, secondDate) {
  var seconds = Math.floor((secondDate - firstDate) / 1000)

  var interval = seconds / 31536000

  if (interval > 1) {
    return Math.floor(interval) + " année"
  }
  interval = seconds / 2592000
  if (interval > 1) {
    return Math.floor(interval) + " mois"
  }
  interval = seconds / 86400
  if (interval > 1) {
    return Math.floor(interval) + " jour"
  }
  interval = seconds / 3600
  if (interval > 1) {
    return Math.floor(interval) + " heures"
  }
  interval = seconds / 60
  if (interval > 1) {
    return Math.floor(interval) + " minutes"
  }
  return Math.floor(seconds) + " seconde"
}

export function between(x, min, max) {
  return x >= min && x <= max
}

export function getNearestExpiryDate(priceRange) {
  if (!priceRange) return null

  const minDate = priceRange.min?.reservationExpiryDate
  const maxDate = priceRange.max?.reservationExpiryDate

  // If both are null, return null
  if (!minDate && !maxDate) return null

  // If only one has a date, return that one
  if (!minDate) return formatDate(new Date(maxDate)).replace(/-/g, "/")
  if (!maxDate) return formatDate(new Date(minDate)).replace(/-/g, "/")

  // If both have dates, return the nearest one
  const minDateObj = new Date(minDate)
  const maxDateObj = new Date(maxDate)
  const now = new Date()

  const minDiff = Math.abs(minDateObj - now)
  const maxDiff = Math.abs(maxDateObj - now)

  return minDiff < maxDiff
    ? formatDate(minDateObj).replace(/-/g, "/")
    : formatDate(maxDateObj).replace(/-/g, "/")
}

export function formatDate(date, withTime) {
  return withTime
    ? formatDateWithTime(date)
    : `${padTo2Digits(date.getDate())}-${padTo2Digits(
        date.getMonth() + 1,
      )}-${date.getFullYear()}`
}

export function formatDateWithTime(date) {
  var hours = date.getHours()
  var minutes = date.getMinutes()
  minutes = minutes < 10 ? "0" + minutes : minutes
  var strTime = hours + ":" + minutes
  return (
    date.getDate() +
    "/" +
    (date.getMonth() + 1) +
    "/" +
    date.getFullYear() +
    "  " +
    strTime
  )
}

export function formatDateAsDayAndTime(input) {
  let date = new Date(input)
  return (
    String(date.getUTCDate()).padStart(2, "0") +
    "-" +
    String(date.getUTCMonth() + 1).padStart(2, "0") +
    " " +
    String(date.getUTCHours()).padStart(2, "0") +
    ":" +
    String(date.getUTCMinutes()).padStart(2, "0")
  )
}

export function formatDateAsTime(date) {
  return padTo2Digits(date.getHours()) + ":" + padTo2Digits(date.getMinutes())
}

export function buildGoogleStaticMapUrl({
  lat,
  lng,
  zoom = 18,
  size = "640x400",
  scale = 2,
  maptype = "satellite",
  markerColor = "red",
  key = import.meta.env.VITE_GMAPS_KEY,
} = {}) {
  const parsedLat = Number.parseFloat(lat)
  const parsedLng = Number.parseFloat(lng)

  if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng) || !key) {
    return null
  }

  const normalizedLat = parsedLat.toFixed(6)
  const normalizedLng = parsedLng.toFixed(6)
  const coordinates = `${normalizedLat},${normalizedLng}`

  const params = new URLSearchParams()
  params.set("center", coordinates)
  params.set("zoom", String(zoom))
  params.set("size", size)
  params.set("scale", String(scale))
  params.set("maptype", maptype)
  params.set("markers", `color:${markerColor}|${coordinates}`)
  params.set("key", key)

  return `https://maps.googleapis.com/maps/api/staticmap?${params.toString()}`
}

export function formatFullAddress(address) {
  return (
    (address?.houseNumber ? `${address.houseNumber} ` : "") +
    (address?.streetLine ? `${address.streetLine}, ` : "") +
    (address?.postcode ? `${address.postcode} ` : "") +
    (address?.district ? `${address.district}` : "")
  )
}

export function formatFullAddressAsGmapsFormat(address) {
  return (
    (address.houseNumber ? `${address.houseNumber} ` : "") +
    (address.streetLine ? `${address.streetLine}, ` : "") +
    (address.city ? `${address.city}, ` : "") +
    (address.country ? `${address.country}` : "")
  )
}

export function addYears(date, years) {
  date.setFullYear(date.getFullYear() + years)
  return date
}

export function addMonths(date, months) {
  date.setMonth(date.getMonth() + months)
  return date
}

export function addDays(date, days) {
  date.setDate(date.getDate() + days)
  return date
}

export function addHours(date, hours) {
  date.setHours(date.getHours() + hours)
  return date
}

export function subtractDays(numOfDays, date = new Date()) {
  date.setDate(date.getDate() - numOfDays)
  return date
}

export function subtractMonths(numOfMonths, date = new Date()) {
  date.setMonth(date.getMonth() - numOfMonths)
  return date
}
export function getInitials(fullName) {
  if (!fullName) return "";
  return fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export function subtractYears(numOfYears, date = new Date()) {
  date.setYear(date.getFullYear() - numOfYears)
  return date
}

export function isToday(date) {
  return new Date().toDateString() === date.toDateString()
}

export async function download(downloadUrl, name, params = {}) {
  const extensions = {
    "image/jpeg": ".jpeg",
    "image/png": ".png",
    "application/pdf": ".pdf",
    "application/json": ".json",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      ".xlsx",
  }

  const response = await axios.get(downloadUrl, {
    params,
    responseType: "blob",
    paramsSerializer: (params) => qs.stringify(params),
  })

  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement("a")

  const contentType = response.headers["content-type"]
  const extension = extensions[contentType] || ".bin"

  const disposition = response.headers["content-disposition"]
  let filenameFromHeader = null

  if (disposition) {
    const match = disposition.match(/filename=([^;]+)/)
    if (match && match[1]) {
      filenameFromHeader = match[1].trim().replace(/^"|"$/g, "")
    }
  }

  const finalFilename = name
    ? name.replace(/\.[^/.]+$/, "") + extension
    : filenameFromHeader || "file" + extension

  link.href = url
  link.setAttribute("download", finalFilename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export function downloadAllFiles(files) {
  const zipPackage = new JSZip()
  const filesPromises = files.map((file) => {
    return axios.get(file.url, { responseType: "blob" }).then((response) => {
      zipPackage.file(file.title, response.data)
    })
  })

  return Promise.all(filesPromises)
    .then(() => zipPackage.generateAsync({ type: "blob" }))
    .then((content) => {
      const url = window.URL.createObjectURL(content)
      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "files.zip")
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
}

export function formatHardwareEquipmentDisplayName(type) {
  let fullName = ""
  if (type.manufacturer)
    fullName = fullName + type.manufacturer.companyName + " - "
  return fullName + type.name
}

export function formatSystemDisplaySize(size) {
  if (!size) return "0 kWc"
  if (size < 1000) return `${size.toFixed(2)} kWc`
  else return `${size / 1000} MWc`
}
export function isValNumber(val) {
  if (val || val === 0) {
    return true
  }
  return false
}

export function formatToArray(val) {
  return Array.isArray(val) ? val : [val]
}

export function validateFileType(files, accept) {
  let isValid = true
  // Normalize accept array to lowercase for case-insensitive comparison
  const normalizedAccept = accept.map((ext) => ext.toLowerCase())

  for (var i = 0; i < files.length; i++) {
    let fileExtension = `.${files[i].name.split(".").pop().toLowerCase()}`
    if (!normalizedAccept.includes(fileExtension)) {
      isValid = false
      break
    }
  }
  return isValid
}

export function getAuroraDesignCadUrl(projectId, designId) {
  return `${auroraSolarWebAppUrl}/projects/${projectId}/designs/${designId}/cad`
}

export function getAuroraDesignSalesModeUrl(projectId, designId) {
  return `${auroraSolarWebAppUrl}/projects/${projectId}/designs/${designId}/e-proposal/design`
}

export function isCrawler() {
  const crawlerRegex = /prerender/i
  if (navigator.userAgent && crawlerRegex.test(navigator.userAgent)) return true
  else return false
}

export function scrapeAddressComponent(place, componentName) {
  const component = place.address_components.filter((c) =>
    c.types.includes(componentName),
  )[0]

  return component ? component.long_name : null
}

export function getHourSlotsNotCovered(hourSlots) {
  let hourSlotsNotCovered = []
  const requiredHourSlots = Array.from(Array(24).keys())
  const formattedHourSlots = hourSlots.map((o) => {
    return {
      start: o.startHours + o.startMinutes / 60,
      end: o.endHours + o.endMinutes / 60,
    }
  })
  requiredHourSlots.forEach((hourSlot) => {
    if (
      !formattedHourSlots.some((o) => o.start <= hourSlot && hourSlot <= o.end)
    )
      hourSlotsNotCovered.push(hourSlot)
  })
  return hourSlotsNotCovered
}

export function isNullOrUndefined(value) {
  return value == null // true for null or undefined, false for anything else (including 0)
}

export const getYoutubeVideoId = (embedUrl) => {
  const regex = /youtube\.com\/embed\/([^?]+)/
  const match = embedUrl.match(regex)
  return match ? match[1] : null
}

export function categoryTextCSS(preset) {
  switch (preset) {
    case "red":
      return "from-red-600"
    case "orange":
      return "from-orange-500 to-yellow-400"
    case "cyan":
      return "from-cyan-500 via-cyan-200 to-cyan-500"
    case "zinc":
      return "from-zinc-500 via-zinc-300 to-zinc-500"
    case "rose":
      return "from-rose-700 via-rose-300 to-rose-700"
    case "pink":
      return "from-pink-700 via-pink-300 to-pink-700"
    case "purple":
      return "from-purple-800 via-purple-400 to-purple-800"
    case "green":
      return "from-green-500 via-green-300 to-green-500"
    case "blue":
      return "from-blue-500 via-blue-400 to-blue-500"
    case "yellow":
      return "from-yellow-500 via-yellow-300 to-yellow-500"
    case "teal":
      return "from-teal-500 via-teal-300 to-teal-500"
    case "fuchsia":
      return "from-fuchsia-600 via-fuchsia-400 to-fuchsia-600"
    case "lime":
      return "from-lime-500"
    case "violet":
      return "from-violet-400 via-violet-200 to-violet-400"
    case "sky":
      return "from-sky-800 via-sky-500 to-sky-700"
    case "slate":
      return "from-slate-200 via-slate-100 to-slate-200"
  }
}

export function categoryTextCSSForPrint(preset) {
  switch (preset) {
    case "red":
      return "text-red-300"
    case "orange":
      return "text-orange-400"
    case "cyan":
      return "text-cyan-300"
    case "zinc":
      return "text-zinc-300"
    case "rose":
      return "text-rose-300"
    case "pink":
      return "text-pink-300"
    case "purple":
      return "text-purple-300"
    case "green":
      return "text-green-300"
    case "blue":
      return "text-blue-300"
    case "yellow":
      return "text-yellow-300"
    case "teal":
      return "text-teal-300"
    case "fuchsia":
      return "text-fuchsia-300"
    case "lime":
      return "text-lime-300"
    case "violet":
      return "text-violet-300"
    case "sky":
      return "text-sky-300"
    case "slate":
      return "text-slate-300"
  }
}

export function cardBackgroundCSS(preset) {
  switch (preset) {
    case "red":
      return "from-red-600"
    case "orange":
      return "from-orange-500 to-yellow-400"
    case "cyan":
      return "from-cyan-500 to-cyan-300"
    case "zinc":
      return "from-zinc-500 to-zinc-300"
    case "rose":
      return "from-rose-700 to-rose-500"
    case "pink":
      return "from-pink-700 to-pink-500"
    case "purple":
      return "from-purple-800 to-purple-600"
    case "green":
      return "from-green-500 to-green-300"
    case "blue":
      return "from-blue-500 to-blue-400"
    case "yellow":
      return "from-yellow-500 to-yellow-300"
    case "teal":
      return "from-teal-500 to-teal-300"
    case "fuchsia":
      return "from-fuchsia-600 to-fuchsia-400"
    case "lime":
      return "from-lime-500"
    case "violet":
      return "from-violet-400 to-violet-200"
    case "sky":
      return "from-sky-800 to-sky-600"
    case "slate":
      return "from-slate-200 to-slate-100"
  }
}

export function getBrowser() {
  let userAgent = navigator.userAgent
  let browser = "Unknown"

  // Detect Chrome
  if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
    browser = "Google Chrome"
  }
  // Detect Chromium-based Edge
  else if (/Edg/.test(userAgent)) {
    browser = "Microsoft Edge"
  }
  // Detect Firefox
  else if (/Firefox/.test(userAgent)) {
    browser = "Mozilla Firefox"
  }
  // Detect Safari
  else if (/Safari/.test(userAgent)) {
    browser = "Apple Safari"
  }
  // Detect Internet Explorer
  else if (/Trident/.test(userAgent)) {
    browser = "Internet Explorer"
  }

  return browser
}


/**
 * Converts a string like 'MY_LIGHT' to 'myLight' or 'MyLight'.
 * @param {string} str
 * @param {boolean} [capitalizeFirst=false] - If true, capitalize the first letter (PascalCase)
 * @returns {string}
 */
export function toCamelCase(str, capitalizeFirst = false) {
  if (!str) return '';
  let result = str
    .toLowerCase()
    .split('_')
    .map((word, idx) => idx === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
  if (capitalizeFirst && result.length > 0) {
    result = result.charAt(0).toUpperCase() + result.slice(1);
  }
  return result;
}

export function createArrayFromLength(length) {
  return Array.from({ length }, (_, i) => i);
}